import * as Cookie from 'js-cookie';
import { forEach } from 'lodash-es';

/**
 * Simple Badge component used to show the number of items in a cart or a wishlist
 */
export default class Badge {
  /**
   * Wrapper element
   */
  els: NodeListOf<HTMLElement>;

  /**
   * Whether the badge should be hidden if the value is '', undefined, or 0
   */
  hideWhenFalsy: boolean;

  /**
   * CSS Class to apply to hide the element
   */
  static HIDDEN_CLASS = 'hidden';

  /**
   * @param {string} selector
   * @param {string | number} value
   * @param {boolean} hideWhenFalsy
   */
  constructor(selector: string, value: string | number, hideWhenFalsy = true) {
    this.els = document.querySelectorAll(selector);
    this.hideWhenFalsy = hideWhenFalsy;
    if (this.els) {
      this.update(value);
    }
  }

  /**
   * Update the badge value
   * @param value
   * @param {boolean} hideWhenFalsy
   */
  update(value) {
    forEach(this.els, (el) => {
      el.firstElementChild.innerHTML = value;
    });
    if (this.hideWhenFalsy && !value) {
      return this.hide();
    }
    return this.show();
  }

  /**
   * Show the badge
   */
  show = () => forEach(this.els, (el) => el.classList.remove(Badge.HIDDEN_CLASS));

  /**
   * Hide the badge
   */
  hide = () => forEach(this.els, (el) => el.classList.add(Badge.HIDDEN_CLASS));

  /**
   * Read and return a number value stored in a cookie
   * @param name
   * @param {number} fallbackValue
   * @returns {number}
   */
  static readFromCookie(name, fallbackValue = 0, localized = false) {
    let value = null;
    if (localized) {
      const parsedCookie = JSON.parse(Cookie.get(name) || '{}');
      value = parsedCookie ? parsedCookie[Phoenix.defaultCountryCode] : null;
    } else {
      value = Number(Cookie.get(name));
    }
    if (!value || isNaN(value)) {
      return fallbackValue;
    }
    return value;
  }

  /**
   * Read and return a string value stored in a cookie
   * @param name
   * @param {string} fallbackValue
   * @returns {string}
   */
  static readStringFromCookie(name, fallbackValue = '') {
    const value = Cookie.get(name);
    if (!value) {
      return fallbackValue;
    }
    return value;
  }
}
